import moment from "moment";
import * as echarts from "echarts";
const getOption = (data1: Array<number>, type: string): any => {
  const x: string[] = [];
  const y: number[] = [];
  const days: string[] = [];
  let min = 0;
  let stationName: string = "";
  data1.forEach((e: any) => {
    x.push(
      moment(e.datetime, "YYYYMMDDHHmmss")
        .add(8, "hour")
        .format("DD日HH") + "时"
    );

    if (min === 0 || e.win_s_avg_2mi < min) {
      min = e.win_s_avg_2mi;
    }
    stationName = e.stationName;
    y.push(Math.round(e.win_s_avg_2mi * 10) / 10);
  });
  min = min - 1 > 0 ? min - 1 : 0;
  const fontSize = 14;
  console.log(Math.round(min));
  let leftPostion = 15;
  let topPostion = 30;
  let yAxisShow = false;
  let splitLine = false;
  let showAllSymbol = false;
  let titleShow = false;
  let xInterval = 5;
  let xLabelFormat = undefined;
  let bottomPostion = 35;
  let dataZoomDisAble = false;
  let dataZoom = 100;
  let tooltipShow = false;
  if (type === "full") {
    leftPostion = 35;
    topPostion = 40;
    titleShow = true;
    xInterval = 1;
    yAxisShow = true;
    splitLine = true;
    showAllSymbol = true;
    dataZoomDisAble = true;
    dataZoom = 100;

    xLabelFormat = function(value: string) {
      let pattern = new RegExp("[\u4E00-\u9FA5]+");
      const values = value.split("");
      let result = "";
      values.forEach((charValue) => {
        result += charValue;
        if (pattern.test(charValue)) {
          result += "\n";
        }
      });
      return result;
    };
    bottomPostion = 80;
    tooltipShow = true;
  }

  return {
    animation: true,
    title: {
      show: titleShow,
      textStyle: {
        color: "#2D96F7",
      },
      text: stationName + "-过去24小时风速(m/s)",
    },
    tooltip: {
      trigger: "axis",
      show: tooltipShow,
    },
    dataZoom: [
      {
        type: "inside",
        disabled: !dataZoomDisAble,
        start: 0,
        end: dataZoom,
      },
    ],
    grid: {
      left: leftPostion,
      right: 10,
      top: topPostion,
      bottom: bottomPostion,
    },
    xAxis: {
      type: "category",
      data: x,
      boundaryGap: true,
      axisLabel: {
        fontFamily: "PingFangSC-Regular",
        interval: xInterval,
        formatter: xLabelFormat,
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "#2D96F7",
        },
      },
      axisTick: {
        show: false,
      },
    },
    yAxis: {
      show: yAxisShow,
      type: "value",
      // min: (value: any) => Math.round((min*10)/10),
      min: min,
      max: (value: any) => Math.round(value.max + 1),
      splitNumber: 1,
      interval: 1,
      splitLine: { show: splitLine },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#2D96F7",
        },
      },
    },
    series: {
      data: y,
      symbol: "circle",
      markPoint: {
        symbol: "pin",
        data: [
          {
            type: "max",
            name: "Max",
            itemStyle: {
              color: "rgba(250, 173, 20, 1)",
            },
          },
          {
            type: "min",
            name: "Min",
            itemStyle: {
              color: "RGBA(53, 154, 248, 0.7)",
            },
          },
        ],
      },
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(17, 134, 242, 0.5)",
          },
          {
            offset: 1,
            color: "rgba(17, 134, 242,0)",
          },
        ]),
      },
      showAllSymbol: showAllSymbol,
      smooth: true,
      label: {
        show: true,
        color: "#2D96F7",
        fontSize,
      },

      lineStyle: {
        width: 2,
        color: "RGBA(64, 161, 250, 1)",
      },

      itemStyle: {
        color: "#2D96F7",
      },
      type: "line",
      yAxisIndex: 0,
    },
  };
};
export default getOption;
